/**
 * Created by vtbelo on 09.08.2022
 */

cc.ZoomAction = function (duration, params) {
    cc.ActionInterval.prototype.constructor.call(this);
    this._params = params;
    cc.ActionInterval.prototype.initWithDuration.call(this, duration);
};

cc.ZoomAction.prototype = Object.assign(Object.create(cc.ActionInterval.prototype), {
    constructor: cc.ZoomAction,

    startWithTarget: function (target) {
        cc.ActionInterval.prototype.startWithTarget.call(this, target);

        const zoomHandler = this.getZoomHandler();
        this._startZoom = zoomHandler.target.zoom;

        this._targetZoom = this._params.zoom;
        if (this._params.maxZoom && this._targetZoom > this._params.maxZoom) {
            this._targetZoom = this._params.maxZoom;
        }

        if (this._params.direction === cleverapps.UI.ZoomHandler.ZOOM_DIRECTION_IN && this._targetZoom < this._startZoom) {
            this._targetZoom = this._startZoom;
        }
        if (this._params.direction === cleverapps.UI.ZoomHandler.ZOOM_DIRECTION_OUT && this._targetZoom > this._startZoom) {
            this._targetZoom = this._startZoom;
        }

        if (this._params.zoomFocus) {
            this._zoomFocusStartPosition = this.target.getContainerPosition();
            this._zoomFocusTargetPosition = this.target.outOfBoundariesVector(this._params.zoomFocus, this._params.focusCenterOffset);
        }
    },

    getZoomHandler: function () {
        return this.target.zoomHandler;
    },

    stop: function () {
        this.getZoomHandler()._zoomRunning = false;
        this.target.onUpdateZoomListener();
    },

    update: function (time) {
        time = this._computeEaseTime(time);
        if (this._zoomFocusTargetPosition) {
            this.target.scrollToPoint(this.target.normalizePoint(cc.pAdd(this._zoomFocusStartPosition, cc.pMult(cc.pSub(this._zoomFocusTargetPosition, this._zoomFocusStartPosition), time))));
        }
        this.getZoomHandler().setZoom(this._startZoom + (this._targetZoom - this._startZoom) * time, true);
        this.getZoomHandler()._zoomRunning = true;
    }
});